import { Dialog } from 'primereact/dialog';

const UsuariosDialog = ({ visible, onHide }) => {
    return (
        <Dialog 
            header="Detalles de Usuarios" 
            visible={visible} 
            className="p-fluid custom-dialog"
            onHide={onHide}
        >
            <div className="grid">
                <div className="col-6">
                    <div className="surface-0 p-3 border-round shadow-1">
                        <div className="text-xl font-bold mb-3">Usuarios Activos</div>
                        <div className="text-4xl text-blue-500 font-bold mb-2">9</div>
                        <span className="text-gray-500">de un total de 80 usuarios registrados</span>
                    </div>
                </div>
                <div className="col-6">
                    <div className="surface-0 p-3 border-round shadow-1">
                        <div className="text-xl font-bold mb-3">Zonas Cubiertas</div>
                        <div className="text-4xl text-orange-500 font-bold mb-2">1</div>
                        <span className="text-gray-500">de un total de 10 zonas disponibles</span>
                    </div>
                </div>
            </div>
        </Dialog>
    );
};

export default UsuariosDialog;